/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import { InfaceAuth } from '@inface-sdk/web-auth'
import Sentry from '../config/sentry.js'

export default class WebAuthService {
  constructor({
    gid, env, platform, locale, __useNppMonitor,
  }) {
    this.infaceAuth = new InfaceAuth({
      gid, env, platform, locale, __useNppMonitor,
    })

    // for debug
    window.insignWebAuth = this.infaceAuth
  }

  // [♻️코드 리팩토링] 유저에게 노출되는 에러 메세지 한 곳에서 관리
  getDisplayMessage({ code, message, data }) {
    switch (code) {
      case 113001: // '미지원 국가'
        return message
      case 113104:
      case 401:
        if (data?.error?.code === -13) {
          return data.error?.message?.includes('20014') ? window.$t('SSO_API_ERROR_INVALID_USER_IP') : window.$t('SSO_API_ERROR_SESSION_NULL')
        }
        return window.$i18next.t('ERROR_OCCURRED')
      case 113110: // 웹티켓 인증 오류
        return window.$i18next.t('error_modal.unauthorized_session', { ns: 'common' })
      default:
        return window.$i18next.t('ERROR_OCCURRED') // '로그인 중 오류 발생'
    }
  }

  /**
   * inface.auth 의 메소드 호출 결과를 Sentry 로그에 추가로 기록합니다.
   * @param {string} methodName
   * @param {number} result.code
   * @param {object} result.data
   * @param {Response} result.response
   * @param {object} result.errorData
   */
  addBreadcrumbByInfaceAuthMethod(methodName, result) {
    Sentry.addBreadcrumb({
      type: 'info',
      category: 'infaceAuthMethod.result',
      message: `[methodName] ${methodName}`,
      data: result,
      level: 'info',
    })
  }

  captureExceptionByInfaceAuthError({
    infaceAuthError, infaceAuth, type,
  } = {}) {
    const {
      code, name, message, response, data,
    } = infaceAuthError
    const xRequestId = response?.headers?.get('x-request-id')

    if (response?.status) {
      Sentry.setContext('API Response Detail', { status: response.status, data: data?.error || {} })
    }

    Sentry.addBreadcrumb({
      type: 'error',
      category: 'infaceAuthError',
      data: infaceAuthError,
      level: 'error',
    })

    Sentry.withScope((scope) => {
      const error = new Error(message)
      error.name = `[${code}] ${name || message}`

      scope.setLevel('error')

      scope.setTag('type', type)
      scope.setTag('x-request-id', xRequestId)

      // issue grouping
      scope.setFingerprint([code, name, message])

      Sentry.addBreadcrumb({
        type: 'info',
        category: 'request',
        data: {
          type,
          xRequestId,
        },
        level: 'info',
      })

      if (infaceAuth.isSignedIn()) {
        // eslint-disable-next-line no-underscore-dangle
        const { guid } = infaceAuth._user.getProfile().local_session_props
        scope.setTag('guid', guid)

        const ifwt = infaceAuth.client.getCookie('_ifwt')
        const ifwtSso = infaceAuth.client.getCookie('_ifwt_sso')
        scope.setTag('_ifwt', ifwt)
        scope.setTag('_ifwt_sso', ifwtSso)

        Sentry.addBreadcrumb({
          type: 'user',
          category: 'user',
          data: {
            guid,
            ifwt,
            ifwtSso,
          },
          level: 'info',
        })
      }

      Sentry.captureException(error)
    })
  }

  async handleError({ infaceAuthError, infaceAuth, type = 'web' } = {}) {
    const {
      code, message, response, data,
    } = infaceAuthError
    const showMessage = this.getDisplayMessage({ code, message, data })

    const iasErrorCode = data?.error?.code ? `(${data.error.code})` : ''
    const xRequestId = response?.headers?.get('x-request-id')
    const errorCode = `\n\n${window.$i18next.t('ERROR_CODE')}: ${code}${iasErrorCode}`
    const contactCode = xRequestId ? `\n${window.$i18next.t('CONTACT_CODE')}: ${xRequestId}` : ''

    const alertMessage = `${showMessage}${errorCode}${contactCode}`
    console.error(alertMessage)

    this.captureExceptionByInfaceAuthError({ infaceAuthError, infaceAuth, type })

    if (type === 'web') { // web 만 모달창 띄움
      await window.$globalModal.warning({ message: alertMessage })
    }
  }
}
